import { useState } from 'react'
import { X } from 'lucide-react'
import { clsx } from 'clsx'

interface ChatImageMessageProps {
  imageUrl: string
  imageWidth?: number
  imageHeight?: number
  imageName?: string
}

export function ChatImageMessage({
  imageUrl,
  imageWidth,
  imageHeight,
  imageName,
}: ChatImageMessageProps) {
  const [fullscreen, setFullscreen] = useState(false)
  const aspectRatio =
    imageWidth && imageHeight ? imageWidth / imageHeight : undefined

  return (
    <>
      <div className="flex flex-col gap-1">
        <button
          type="button"
          onClick={() => setFullscreen(true)}
          className="block text-left"
        >
          <img
            src={imageUrl}
            alt={imageName || '이미지'}
            className={clsx(
              'rounded-lg max-w-60 cursor-pointer hover:opacity-90 transition-opacity',
              'object-cover'
            )}
            style={aspectRatio ? { aspectRatio: String(aspectRatio) } : undefined}
            loading="lazy"
          />
        </button>
        {imageName && (
          <span className="text-meta text-caption truncate max-w-60">
            {imageName}
          </span>
        )}
      </div>

      {/* 풀스크린 이미지 뷰어 */}
      {fullscreen && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center"
          onClick={() => setFullscreen(false)}
        >
          <button
            onClick={() => setFullscreen(false)}
            className="absolute top-4 right-4 p-2 text-white/70 hover:text-white rounded-full bg-white/10 hover:bg-white/20 transition-colors z-10"
          >
            <X className="w-6 h-6" />
          </button>
          <img
            src={imageUrl}
            alt={imageName || '이미지'}
            className="max-w-[95vw] max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  )
}
